<div class="container-fluid">

  <h4 id="upper">Prévision budgétaire</h4>

  <div class="row">
    <div class="col-lg-12">
      <div class="card">
        <div class="card-body">
          <div class="row mb-3 d-flex justify-content-between align-items-center">
            <div class="col-auto">
              <input type="file" class="d-none" #importFile accept=".xlsx,.xls,.csv" (change)="onFileSelected($event)">
              <button type="button" class="btn btn-primary mb-2" (click)="importFile.click()">
                <i class="mdi mdi-file-excel me-2"></i> Importer (Excel)
              </button>
            </div>
            <div class="col-sm-12 col-md-9 col-lg-8">
              <div class="d-flex justify-content-end align-items-center gap-2 flex-wrap">
                <label class="mb-0">Chapitre</label>
                <select class="form-select form-select-sm" style="width: 280px;" [(ngModel)]="selectedChapitre"
                  (change)="loadSousChapitres()">
                  <option [ngValue]="null">Tous les chapitres</option>
                  <option *ngFor="let item of chapitres" [ngValue]="item.reference">
                    {{ item.code }} - {{ item.libelle }}
                  </option>
                </select>
                <label class="mb-0">Sous-chapitre</label>
                <select class="form-select form-select-sm" style="width: 280px;" [(ngModel)]="selectedSousChapitre"
                  (change)="loadData()">
                  <option [ngValue]="null">Tous les sous-chapitres</option>
                  <option *ngFor="let item of sousChapitres" [ngValue]="item.reference">
                    {{ item.code }} - {{ item.libelle }}
                  </option>
                </select>
              </div>
            </div>
          </div>

          <div class="table-responsive mt-3">
            <table class="table table-centered datatable dt-responsive nowrap"
              style="border-collapse: collapse; border-spacing: 0; width: 100%;">
              <thead class="thead-light rwd-table">
                <tr>
                  <th style="width: 20px;"></th>
                  <th>Code</th>
                  <th>Compte budgétaire</th>
                  <th class="text-end">Budget primitif</th>
                  <th class="text-end">Modification</th>
                  <th class="text-end">Total prévisionnel</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of paginatedProjets; let i = index">
                  <td></td>
                  <td>{{ item.code }}</td>
                  <td>{{ item.libelle }}</td>
                  <td class="text-end">{{ (item.prevision?.budget_primitif || 0) | number:'1.0-0' }}</td>
                  <td class="text-end">{{ (item.prevision?.modification || 0) | number:'1.0-0' }}</td>
                  <td class="text-end">{{ (item.prevision?.total_previsionnel || 0) | number:'1.0-0' }}</td>
                  <td>
                    <button (click)="openModal(item)" type="button" class="btn btn-success btn-sm">
                      <i class="mdi mdi-cash-multiple font-size-18 me-1"></i> Budgétiser
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="d-flex justify-content-center" *ngIf="!isLoading">
            <div class="container">
              <div class="row">
                <div class="text-center">
                  <h6 id="graycolor">chargement en cours</h6>
                  <div class="loader4"></div>
                </div>
              </div>
            </div>
          </div>

          <div *ngIf="paginatedProjets.length === 0 && isLoading" class="d-flex justify-content-center">
            <h5 id="graycolor">Aucune prévision trouvée</h5>
          </div>

          <p-paginator (onPageChange)="onPageChange($event)" [first]="first" [rows]="rows"
            [totalRecords]="totalRecords" [rowsPerPageOptions]="[10, 20, 30]">
          </p-paginator>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #previsionModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Budgétiser le compte budgétaire</h5>
    <button type="button" class="close" aria-label="Close" (click)="modal.close()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body p-3">
    <form>
      <div class="row mb-3">
        <div class="form-group col-md-3">
          <label>Code</label>
          <input class="form-control" [value]="selectedCompte?.code" disabled>
        </div>
        <div class="form-group col-md-9">
          <label>Compte budgétaire</label>
          <input class="form-control" [value]="selectedCompte?.libelle" disabled>
        </div>
      </div>
      <div class="row mb-3">
        <div class="form-group col-md-4">
          <label>Budget primitif</label>
          <input type="number" min="10000" class="form-control" [(ngModel)]="previsionForm.budget_primitif" name="budget_primitif"
            (ngModelChange)="calculateModification()">
        </div>
        <div class="form-group col-md-4">
          <label>Budget total</label>
          <input type="number" min="10000" class="form-control" [(ngModel)]="previsionForm.total_previsionnel" name="total_previsionnel"
            (ngModelChange)="calculateModification()">
        </div>
        <div class="form-group col-md-4">
          <label>Modification</label>
          <input type="number" class="form-control" [(ngModel)]="previsionForm.modification" name="modification" disabled>
        </div>
      </div>
      <div class="text-end mt-3">
        <button (click)="modal.close()" type="button" class="btn btn-light ms-1">
          <i class="pi pi-times" style="color: #212529"></i> Annuler
        </button>&nbsp;
        <button (click)="save()" type="button" class="btn btn-success">
          <i class="pi pi-save" style="color: white"></i> Valider
        </button>
      </div>
    </form>
  </div>
</ng-template>

<p-confirmDialog></p-confirmDialog>
<p-toast position="center"></p-toast>
<ngx-ui-loader></ngx-ui-loader>
